import styles from './style.module.css'
import React from 'react'

export default function Loader(){
    return (
        <div className={styles.loader}>
        </div>
    )
}